/**
 * @name 渲染表单组件
 */
import base from '../../base';
import Breadcrumb from './breadcrumb';

Breadcrumb.install = function(Vue) {
  Vue.use(base);
  Vue.component(Breadcrumb.name, Breadcrumb);
};

export default Breadcrumb;
